import http from "@/settings/apiSettings";

class ERP_LogoDataService {
  /** Logo-ul companiei curente (ERP_Imagini, TipImagine='Logo'). null dacă firma nu are logo încărcat. */
  getLogoObjectUrl(): Promise<string | null> {
    return http.client
      .get("/ERP_Logo", {
        responseType: "blob",
        headers: { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") },
      })
      .then((r: any) => URL.createObjectURL(r.data))
      .catch(() => null);
  }
}

export default new ERP_LogoDataService();
